import React from "react";
import "./styles.scss";
import "./styles.css";

export default function Stepper({ title, steps, activeStep, subText }) {
  return (
    <div className="stepper stepper-pills d-flex flex-column stepper-2-container" id="kt_stepper_example_basic">
      <div className="justify-content-center mt-10px">
        <div className="head-text text-center">
          {title}{" "}
        </div>
        {/* <div className="head-sub-text">{subText}</div> */}
      </div>
      <div className="stepper-nav py-1 d-flex mb-6 justify-content-center">
        {steps.map((each, index) => {
          return (
            <div className={`stepper-item mx-2 my-4 ${activeStep === index + 1 ? "current" : ""}`} data-kt-stepper-element="nav">
              <div className="stepper-line w-30px"></div>
              <div className="stepper-icon w-30px h-30px rounded-circle">
                <i className="stepper-check fas fa-check"></i>
                <span className="stepper-number">{index + 1}</span>
              </div>
              <div className="stepper-label">
                <h3 className="stepper-title">{each}</h3>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
